<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import Branches from "../components/Branches.svelte";
	import type { VouchersProps } from "./VouchersProps";
	import WeddingsBanner from "../components/Wedding/WeddingsBanner.svelte";
	import Content from "../components/Content.svelte";
	import VoucherCard from "../components/Voucher/VoucherCard.svelte";

	type $$Props = VouchersProps;
	const { plannedIceCreams, vouchers } = $$restProps as $$Props;
</script>

<Layout>
	<div class="container">
		<section>
			<h1
				class="mb-8 mt-5 p-0 text-center text-[2rem] font-semibold leading-10 lg:mb-[1.625rem] lg:mt-0 lg:text-xl lg:leading-[3.25rem]"
			>
				{nbspify("Dárkové poukazy")}
			</h1>
			<div class="mx-auto my-4 max-w-[700px] text-base">
				<!-- TODO SD-348 -->
				<Content content={"Potěšte své blízké a darujte jim náš dárkový poukaz. Platnost poukazu je 12 měsíců."} />
			</div>

			<div class="product-card-wrapper">
				{#each vouchers as voucher}
					<VoucherCard {voucher} />
				{/each}
			</div>
		</section>

		<section>
			<WeddingsBanner />
		</section>

		<section>
			<Branches {plannedIceCreams} />
		</section>
	</div>
</Layout>
